import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { VolumePreview } from './components/VolumePreview';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { WhoItsFor } from './components/WhoItsFor';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { SessionAnatomy } from './components/SessionAnatomy';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-light text-ink font-sans selection:bg-shuttle selection:text-ink" data-id="element-0" data-mp="3mjg9vlcoy9m7">
      <MetaPixel data-id="element-1" data-mp="5osn3wyp084" />
      <main data-id="element-2" data-mp="67z9oh5w26u">
        <Hero data-id="element-3" data-mp="4wx1t3d72hu" />
        <SocialProofBar data-id="element-4" data-mp="5gfrc0u9uwx" />
        <PainGrid data-id="element-5" data-mp="82ohezguggq" />
        <ProductReveal data-id="element-6" data-mp="2zld1d7i6tbah" />
        <Tomes data-id="element-7" data-mp="2zlv8x0aavbxp" />
        <VolumePreview data-id="element-8" data-mp="2zmeo498kfm81" />
        <Bonuses data-id="element-9" data-mp="2zn69yscd25l4" />
        <ValueStack data-id="element-10" data-mp="33mouhn09senf" />
        <Urgency data-id="element-11" data-mp="33m5a7zn5de68" />
        <Pricing data-id="element-12" data-mp="33nq6put0v76q" />
        {shortTestimonials.length > 0 ? <Testimonials testimonials={shortTestimonials} background="white" data-id="element-13" data-mp="38lrpsfqg76i7" /> : <WhoItsFor data-id="element-14" data-mp="3dkuv81acbeqp" />}
        <Guarantee data-id="element-15" data-mp="3dl4mds74frxz" />
        <Faq data-id="element-16" data-mp="3dlns8ajhypvn" />
        {moreTestimonials.length > 0 ? <Testimonials testimonials={moreTestimonials} title="More coaches, more seasons" background="light" data-id="element-17" data-mp="nvsub5qlapwh" /> : <SessionAnatomy data-id="element-18" data-mp="swqbbezv5dwe" />}
        <CostOfInaction data-id="element-19" data-mp="35yo8huu3i0e" />
        <Close data-id="element-20" data-mp="356sn718lka4" />
      </main>
      <Footer data-id="element-21" data-mp="38kxqn1ac7l9" />
      <PurchaseNotifications data-id="element-22" data-mp="38b2ol1dva8p" />
    </div>;
}